import React, { useEffect, useState, useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import restService from "../../../../restService";
import { addDays } from "date-fns";
import { DatePicker } from "../../../components";
import CampaignContext from "../../../../contexts/CampaignContext";
import { PulseLoader } from "react-spinners";

const OutletsPerformance = () => {
  const [campaign] = useContext(CampaignContext);
  const [loading, setLoading] = useState(false);
  const [generatedRes, setGeneratedRes] = useState(null);
  const [dates, setDates] = useState([]);
  const [items, setItems] = useState({
    firstItem: {
      name: "",
      value: [],
    },
    secondItem: {
      name: "",
      value: [],
    },
    thirdItem: {
      name: "",
      value: [],
    },
    fourthItem: {
      name: "",
      value: [],
    },
    fifthItem: {
      name: "",
      value: [],
    },
  });

  const [errorMessage, setErrorMessage] = useState(null);

  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
      endDate: new Date().setHours(23, 59, 59, 0),
      key: "selection",
    },
  ]);

  const [searchList, setSearchList] = useState([
    "ANNAPURNA IODISED SALT 200G 100",
    "PEPSODENT TOOTHPASTE CHARCOAL BLACK 130G 72",
    "PEPSODENT TOOTHPASTE CHARCOAL WHITE 130G 72",
  ]);
  const [tempSearchList, setTempSearchList] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTags, setSearchTags] = useState([]);
  const options = {
    colors: ["#262C6E", "#72ADFF", "#00C74C", "#FF6A3A", "#b80f7a"],
    chart: {
      type: "spline",
    },
    title: {
      text: "",
    },
    legend: {
      // align: "top",
      // layout: "vertical",
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
    },
    credits: {
      enabled: false,
    },

    xAxis: {
      categories: dates,
      crosshair: true,
      type: "datetime",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      // pointFormat:
      // '<tr><td style="color:{series.color};padding:0">{series.name}: </td>',
      // '<td style="padding:0"><b>{point.y}</b></td></tr> <br /> <tr><td style="color:{series.color};padding:0">Percentage: </td> { + } <td style="padding:0"><b>{point.percentage:.0f}%</b></td></tr> ',
      // footerFormat: "</table>",
      // shared: true,
      // useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,

        // stacking: "percent",
      },
    },
    series: [
      {
        name: items.firstItem.name,
        data: items.firstItem.value,
      },
      {
        name: items.secondItem.name,
        data: items.secondItem.value,
      },
      {
        name: items.thirdItem.name,
        data: items.thirdItem.value,
      },
      {
        name: items.fourthItem.name,
        data: items.fourthItem.value,
      },
      {
        name: items.fifthItem.name,
        data: items.fifthItem.value,
      },
    ],
  };

  useEffect(() => {
    const result = [
      {
        date: "2022-11-01",
        report: {
          skus: {
            "ANNAPURNA IODISED SALT 200G 100": 6,
            "PEPSODENT TOOTHPASTE CHARCOAL WHITE 130G 72": 67,
            "PEPSODENT TOOTHPASTE CHARCOAL BLACK 130G 72": 211,
          },

          location: {
            Makola: 96,
            Awoshie: 70,
            Lapaz: 21,
          },
        },
      },

      {
        date: "2022-11-02",
        report: {
          skus: {
            "ANNAPURNA IODISED SALT 200G 100": 96,
            "PEPSODENT TOOTHPASTE CHARCOAL WHITE 130G 72": 20,
            "PEPSODENT TOOTHPASTE CHARCOAL BLACK 130G 72": 43,
          },

          location: {
            Makola: 96,
            Awoshie: 70,
            Lapaz: 21,
          },
        },
      },
      {
        date: "2022-11-03",
        report: {
          skus: {
            "ANNAPURNA IODISED SALT 200G 100": 46,
            "PEPSODENT TOOTHPASTE CHARCOAL WHITE 130G 72": 150,
            "PEPSODENT TOOTHPASTE CHARCOAL BLACK 130G 72": 43,
          },

          location: {
            Makola: 96,
            Awoshie: 70,
            Lapaz: 21,
          },
        },
      },
      {
        date: "2022-11-04",
        report: {
          skus: {
            "ANNAPURNA IODISED SALT 200G 100": 74,
            "PEPSODENT TOOTHPASTE CHARCOAL WHITE 130G 72": 20,
            "PEPSODENT TOOTHPASTE CHARCOAL BLACK 130G 72": 43,
          },

          location: {
            Makola: 93,
            Awoshie: 70,
            Lapaz: 21,
          },
        },
      },
    ];

    if (tempSearchList.length < 2) {
      setGeneratedRes(false);
      const tempDate = [];

      for (let i = 0; i < result.length; i++) {
        tempDate.push(result[i].date);
      }

      let dateString = [];
      for (let i = 0; i < tempDate.length; i++) {
        dateString.push(new Date(tempDate[i]).toString().substring(4, 10));
      }

      const sortedDate = dateString.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      setDates(sortedDate);

      const entries = result.map((e) => {
        return { date: e.date, ...e.report.skus };
      });

      const newEn = entries.map((en, i) => {
        return {
          ...Object.keys(en).map((e, ind) => {
            return { [e]: [en.date, Object.values(en)[ind]] };
          }),
        };
      });

      let fir = [];
      let sec = [];
      let third = [];
      let fourth = [];
      let fifth = [];
      let firName = "";
      let secName = "";
      let thirdName = "";
      let fourthName = "";
      let fifthName = "";

      newEn.map((en) => {
        for (let i = 0; i < Object.keys(en).length; i++) {
          for (const [key, value] of Object.entries(en[i])) {
            if (key === searchList[0]) {
              firName = key;
              fir.push(value);
            }
            if (key === searchList[1]) {
              secName = key;
              sec.push(value);
            }

            if (key === searchList[2]) {
              thirdName = key;
              third.push(value);
            }
            if (key === searchList[3]) {
              fourth.push(value);
              fourthName = key;
            }
            if (key === searchList[4]) {
              fifth.push(value);
              fifthName = key;
            }
          }
        }
      });

      setItems({
        ...items,

        firstItem: {
          ...items.firstItem,
          name: firName,
          value: fir,
        },
        secondItem: {
          ...items.secondItem,
          name: secName,
          value: sec,
        },
        thirdItem: {
          ...items.thirdItem,
          name: thirdName,
          value: third,
        },
        fourthItem: {
          ...items.fourthItem,
          name: fourthName,
          value: fourth,
        },
        fifthItem: {
          ...items.fifthItem,
          name: fifthName,
          value: fifth,
        },
      });
    }
  }, [tempSearchList]);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    try {
      const {
        data: { data },
      } = await restService.Insights.searchLocationInsights(campaign.id, value);

      setSearchTags(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onPressClear = (e) => {
    if (searchTerm && e.code === "Enter") {
      let tempArr = tempSearchList;

      if (tempArr.length === 5) {
        setErrorMessage("You can only add up to 5 Outlets");
      } else {
        tempArr.push(searchTerm);
        setTempSearchList([...new Set(tempArr)]);
        setSearchTerm("");
      }
    }
  };

  const handleAddItems = () => {
    if (searchTerm) {
      let tempArr = tempSearchList;
      if (tempArr.length === 5) {
        setErrorMessage(
          "You can only add up to 5 Outlets to compare thier performance"
        );
      } else {
        tempArr.push(searchTerm);
        setTempSearchList([...new Set(tempArr)]);
        setSearchTerm("");
      }
    }
  };

  const handleViewPerformance = async () => {
    setLoading(true);
    if (tempSearchList.length < 1) {
      setErrorMessage("Add minimum of 1 Outlet to view performance");
      setLoading(false);
      return;
    }

    try {
      const {
        data: { data },
      } = await restService.Insights.getLocationsInsights(
        // campaign.id,
        "",
        "2022-06-30",
        "2022-07-9",
        // new Date(state[0].startDate).toISOString().slice(0, 10),
        // new Date(state[0].endDate).toISOString().slice(0, 10),
        String(tempSearchList)
      );

      const tempDate = [];

      for (let i = 0; i < data.length; i++) {
        tempDate.push(data[i].date);
      }

      let dateString = [];
      for (let i = 0; i < tempDate.length; i++) {
        dateString.push(new Date(tempDate[i])?.toString()?.substring(4, 10));
      }

      const sortedDate = dateString.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      setDates(sortedDate);

      const entries = data.map((e) => {
        return { date: e.date, ...e.report.outlet };
      });

      const newEn = entries.map((en, i) => {
        return {
          ...Object.keys(en).map((e, ind) => {
            return {
              [e]: [
                new Date(en?.date)?.toISOString()?.slice(0, 10),
                Object.values(en)[ind],
              ],
            };
          }),
        };
      });

      let fir = [];
      let sec = [];
      let third = [];
      let fourth = [];
      let fifth = [];
      let firName = "";
      let secName = "";
      let thirdName = "";
      let fourthName = "";
      let fifthName = "";

      newEn.map((en) => {
        for (let i = 0; i < Object.keys(en).length; i++) {
          for (const [key, value] of Object.entries(en[i])) {
            if (key === tempSearchList[0]) {
              firName = key;
              fir.push(value);
            }
            if (key === tempSearchList[1]) {
              secName = key;
              sec.push(value);
            }

            if (key === tempSearchList[2]) {
              thirdName = key;
              third.push(value);
            }
            if (key === tempSearchList[3]) {
              fourth.push(value);
              fourthName = key;
            }
            if (key === tempSearchList[4]) {
              fifth.push(value);
              fifthName = key;
            }
          }
        }
      });

      setItems({
        ...items,

        firstItem: {
          ...items.firstItem,
          name: firName,
          value: fir,
        },
        secondItem: {
          ...items.secondItem,
          name: secName,
          value: sec,
        },
        thirdItem: {
          ...items.thirdItem,
          name: thirdName,
          value: third,
        },
        fourthItem: {
          ...items.fourthItem,
          name: fourthName,
          value: fourth,
        },
        fifthItem: {
          ...items.fifthItem,
          name: fifthName,
          value: fifth,
        },
      });

      setGeneratedRes(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (generatedRes) {
      handleViewPerformance();
    }
  }, [tempSearchList, generatedRes, state]);

  return (
    <div className="bg-white shadow w-full flex flex-col gap-2 py-4 px-8">
      <div className="flex items-center justify-between md:flex-row flex-col gap-3">
        <div className="flex items-center gap-2">
          <label className="relative block">
            <span className="sr-only">Search</span>
            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
              <svg
                width="14"
                height="14"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.21879 9.21873L6.64941 6.64935"
                  stroke="#848484"
                  strokeMiterlimit="10"
                  // strokeMiterlimit="square"
                />
                <path
                  d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
                  stroke="#848484"
                  strokeMiterlimit="10"
                  // strokeMiterlimit="square"
                />
              </svg>
            </span>
            <input
              type="text"
              list="location-datalist"
              placeholder="Search Outlets"
              onChange={(e) => {
                handleSearch(e);
                setErrorMessage(null);
              }}
              value={searchTerm}
              // onKeyPress={onPressClear}
              onKeyDown={onPressClear}
              className="py-1.5 pl-8 border-none w-full focus:border-none focus:outline-none rounded-md bg-[#F4F4F4] "
            />
          </label>
          <button
            onClick={handleAddItems}
            className="bg-[#3989DD1a] text-[#3989DD] text-sm rounded px-2 py-1 font-[700]"
          >
            Add
          </button>
          <datalist id="location-datalist" className="appearance-none p-1">
            {searchTags.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </datalist>
        </div>

        <div className="border rounded">
          <DatePicker state={state} setState={setState} />
        </div>
      </div>
      {errorMessage ? (
        <p className="text-xs text-[#ff0000]">{errorMessage}</p>
      ) : (
        <div className="flex items-start">
          <p
            className="cursor-pointer bg-[#3989DD] rounded-full text-xs text-white font-[700] w-[15px] h-[15px] flex items-center justify-center"
            type="button"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="Add up to 5 Outlets to view their performances"
          >
            ?
          </p>
        </div>
      )}

      {tempSearchList.length > 0 && (
        <div className="w-full">
          <ul className="flex w-full gap-2 flex-wrap border rounded py-3 px-2">
            {tempSearchList.map((item, i) => (
              <li
                key={i}
                className="bg-gray-300 flex items-center gap-2 rounded text-xs px-2 py-1"
              >
                <p>{item}</p>
                <button
                  onClick={() => {
                    let temp = tempSearchList;
                    setErrorMessage(null);
                    let newTemp = temp.filter((x) => x !== item);

                    setTempSearchList(newTemp);
                  }}
                  className="shadow cursor-pointer px-[3px] py-[1px] bg-[#ff0000] text-[#fff]"
                >
                  X
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="w-full flex items-center justify-center mt-5">
        <h3 className="font-[700] text-xl">Outlets Performance</h3>
      </div>

      {loading ? (
        <div className="min-h-[50vh]">
          <PulseLoader color="#FF6A3A" />
        </div>
      ) : (
        <>
          {!generatedRes || tempSearchList.length < 1 ? (
            <div className="mt-10 relative">
              <div className="absolute left-0 right-0 top-0 bottom-0 z-20"></div>
              <div className="w-full top-0 bottom-0 z-30 absolute flex items-center justify-center">
                <button
                  disabled={tempSearchList.length < 1}
                  onClick={handleViewPerformance}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Add minimum of 1 Outlet to view performances"
                  className="bg-[#fc450b] disabled:opacity-[.4] disabled:cursor-not-allowed cursor-pointer px-4 py-2 text-white rounded"
                >
                  View Performance
                </button>
              </div>
              <div className="blur-sm">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options}
                  updateArgs={[true, true, true]}
                />
              </div>
            </div>
          ) : (
            <div className="mt-10 ">
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                updateArgs={[true, true, true]}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default OutletsPerformance;
